import { QATest } from '@src/application/modules/tag/shared/tag/types';
import { useTag } from '../../shared/tag/useTag';

export const useCampaignConditions = (campaign: QATest) => {
  const { trigger, segment } = campaign.targetings;
  const { displayFrequencyType, displayFrequencyUnit, displayFrequencyValue } = campaign.testDatas;
  const { mappedConditions } = useTag();

  const formatConditions = (audience) => {
    const mapAudienceNameToPosition = new Map<number, string>();

    const conditions = audience
      .flatMap(({ name, conditions, success, audiencePosition, audienceName }) =>
        mappedConditions(name, conditions).map((condition) => ({
          ...condition,
          name,
          success,
          audiencePosition,
          audienceName,
        }))
      )
      .reduce((acc, { audiencePosition, audienceName, ...condition }) => {
        if (typeof acc[audiencePosition] === 'undefined') {
          mapAudienceNameToPosition.set(audiencePosition, audienceName);
          acc[audiencePosition] = [condition];
        } else {
          acc[audiencePosition].push(condition);
        }
        return acc;
      }, {} as any);

    return { conditions, mapAudienceNameToPosition };
  };

  const { mapAudienceNameToPosition: mapSegmentNameToPosition, conditions: segmentConditions } =
    (segment && segment.length && formatConditions(segment)) || {};

  const { mapAudienceNameToPosition: mapTriggerNameToPosition, conditions: triggerConditions } =
    (trigger && trigger.length && formatConditions(trigger)) || {};

  const displayFrequency = {
    displayFrequencyType,
    displayFrequencyUnit,
    displayFrequencyValue,
  };

  return {
    segment: segmentConditions,
    mapSegmentNameToPosition,
    trigger: triggerConditions,
    mapTriggerNameToPosition,
    displayFrequency,
  } as const;
};
